<template>
  <div id="updates_page">
    <div class="centered">
      <div class="head">
        <h1>עדכונים שוטפים</h1>
      </div>
      <ul class="items">
        <li v-for="item in updates" :key="item.title">
          <h5 v-html="item.title"></h5>
          <div  v-html="item.desc"></div>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      updates: []
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.api({ action: 'updates/results', data: {  }, method: 'post'}, (data)=>{
        this.updates = data.data.items;
        this.api({ action: 'updates/add_view', data: { }, method: 'post'})
      })
    }
  }
}
</script>

<style lang="scss">
#updates_page {
  .head { margin-bottom: var(--gap_mid);
    h1 { font-size: var(--h2); color: var(--btn_color);  }
  }
  ul.items { display: flex; flex-direction: column; gap: var(--gap_mid);
    &>li { padding: var(--gap_mid); background: #fff; border-radius: var(--radius_md);     box-shadow: var(--box-shadow);
      h5 { font-size: var(--h3); font-weight: bold; }
      div { font-weight: normal;  font-size: var(--h5); }
      h5, div { color: var(--btn_color); }
    }
  }
}
</style>